import BaseProxy from './Proxy';

class VideoSearchProxy extends BaseProxy {
  /**
   * The constructor for the VideoSearchProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(query) {
    super('vms-admin/video-global-search', {q:query});
  }
}

export default VideoSearchProxy;